module.exports = __webpack_public_path__ + "static/service-banner-role-8d54c7127473b73325aadedadea2d4ac.jpeg";